import React from 'react';
import { useTranslation } from 'react-i18next';
import { EventCard } from './EventCard';

const EventList = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto mt-10 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-y-10 justify-items-center">
        {/* <EventCard
          title="Vineyard Team"
          subheader="Vine-to-Wine Water Treatment Solutions"
          altImageText="Vine to Wine"
          image="https://www.vineyardteam.org/images/events/vine%20to%20wine%201.png"
          dateText="Apr 10, 2024"
          timeText="9:00am-11:00am"
          location="Lompoc, CA"
          mainText="Learn from a panel of experts about Reverse Osmosis as a water
              treatment option, their experience using it, the operational and
              technical processes to maintain RO systems, and cost analysis."
          signUpURL="https://vineyardteam.app.neoncrm.com/np/clients/vineyardteam/eventRegistration.jsp?event=197"
          learnMoreURL="https://vineyardteam.app.neoncrm.com/np/clients/vineyardteam/event.jsp?event=197&"
        />


        <EventCard
          title="Wild Farm Alliance"
          subheader="Tablas Creek Vineyard Field Day"
          altImageText="Vineyard Field Day"
          image="https://assets.nationbuilder.com/wildfarmalliance/pages/2010/features/original/Llamas-tablas-header.jpg?1710538713"
          dateText="Apr 25, 2024"
          timeText="8:00am-12:30pm"
          location="Paso Robles, CA"
          mainText="Join Tablas Creek Vineyard, Wild Farm Alliance (WFA), and The
          Vineyard Team out in the field! The event will feature a series of
          talks given by growers and agricultural professionals, a panel
          discussion, and a beneficial habitat walk."
          signUpURL="https://www.wildfarmalliance.org/tablas?utm_campaign=march_enews_2024&utm_medium=email&utm_source=wildfarmalliance"
          learnMoreURL="https://www.wildfarmalliance.org/tablas?utm_campaign=march_enews_2024&utm_medium=email&utm_source=wildfarmalliance"
        />

        <EventCard
          title="Elationscapes"
          subheader="Invitation to Permaculture Workshop"
          altImageText="Invitation to Permaculture Workshop"
          image="https://upload.wikimedia.org/wikipedia/commons/c/c8/Permaculture_garden.JPG"
          dateText="Apr 27, 2024"
          timeText="10:00am-1:00pm"
          location="San Miguel, CA"
          mainText="Join us for a tour of a non-profit grow-to-donate vegetable farm
          and fruit orchard in San Miguel. We will discuss the design of the
          farm, terracing, water system, crop layout and rotation, and
          Spring planting preparations."
          signUpURL="https://www.eventbrite.com/e/design-build-from-raw-land-to-small-farm-tickets-820397379647?aff=oddtdtcreator"
          learnMoreURL="https://slopermaculture.weebly.com/upcoming-events.html"
        /> */}

        <EventCard
          title={t('eventsPage.cards.laFarmerListening.title')}
          subheader={t('eventsPage.cards.laFarmerListening.subheader')}
          altImageText={t('eventsPage.cards.laFarmerListening.altImageText')}
          image="https://i0.wp.com/caff.org/wp-content/uploads/2024/09/2.png?resize=1536%2C864&ssl=1"
          dateText={t('eventsPage.cards.laFarmerListening.dateText')}
          timeText={t('eventsPage.cards.laFarmerListening.timeText')}
          location={t('eventsPage.cards.laFarmerListening.location')}
          mainText={t('eventsPage.cards.laFarmerListening.mainText')}
          signUpURL="https://actionnetwork.org/events/los-angeles-farmer-listening-session-2024"
          learnMoreURL="https://actionnetwork.org/events/los-angeles-farmer-listening-session-2024"
        />

        <EventCard
          title={t('eventsPage.cards.climateSmartFarming.title')}
          subheader={t('eventsPage.cards.climateSmartFarming.subheader')}
          altImageText={t('eventsPage.cards.climateSmartFarming.altImageText')}
          image="https://upload.wikimedia.org/wikipedia/commons/c/c8/Permaculture_garden.JPG"
          dateText={t('eventsPage.cards.climateSmartFarming.dateText')}
          timeText={t('eventsPage.cards.climateSmartFarming.timeText')}
          location={t('eventsPage.cards.climateSmartFarming.location')}
          mainText={t('eventsPage.cards.climateSmartFarming.mainText')}
          signUpURL="https://surveys.ucanr.edu/survey.cfm?surveynumber=43762"
          learnMoreURL="https://www.calfarmdemo.org/events/climate-smart-farming-demonstration-field-meeting/"
        />

        <EventCard
          title={t('eventsPage.cards.sustainableAgExpo.title')}
          subheader={t('eventsPage.cards.sustainableAgExpo.subheader')}
          altImageText={t('eventsPage.cards.sustainableAgExpo.altImageText')}
          image="https://www.vineyardteam.org/images/events/2024%20sae.png"
          dateText={t('eventsPage.cards.sustainableAgExpo.dateText')}
          timeText={t('eventsPage.cards.sustainableAgExpo.timeText')}
          location={t('eventsPage.cards.sustainableAgExpo.location')}
          mainText={t('eventsPage.cards.sustainableAgExpo.mainText')}
          signUpURL="https://vineyardteam.app.neoncrm.com/np/clients/vineyardteam/eventRegistration.jsp?event=192"
          learnMoreURL="https://vineyardteam.app.neoncrm.com/np/clients/vineyardteam/event.jsp?event=192&"
        />

        <EventCard
          title={t('eventsPage.cards.sustainableWinegrowing.title')}
          subheader={t('eventsPage.cards.sustainableWinegrowing.subheader')}
          altImageText={t('eventsPage.cards.sustainableWinegrowing.altImageText')}
          image="https://www.vineyardteam.org/images/events/Virtual%20round%20table%202_western%20SARE_800x500.jpg"
          dateText={t('eventsPage.cards.sustainableWinegrowing.dateText')}
          timeText={t('eventsPage.cards.sustainableWinegrowing.timeText')}
          location={t('eventsPage.cards.sustainableWinegrowing.location')}
          mainText={t('eventsPage.cards.sustainableWinegrowing.mainText')}
          signUpURL="https://vineyardteam.app.neoncrm.com/np/clients/vineyardteam/eventRegistration.jsp?event=253"
          learnMoreURL="https://vineyardteam.app.neoncrm.com/np/clients/vineyardteam/event.jsp?event=253&"
        />

        <EventCard
          title={t('eventsPage.cards.ecoFarm.title')}
          subheader={t('eventsPage.cards.ecoFarm.subheader')}
          altImageText={t('eventsPage.cards.ecoFarm.altImageText')}
          image="https://images.squarespace-cdn.com/content/v1/64c2ee1fc10f2205e1d2508f/1708115281326-QZNMXTP73HNTUHF890VW/image-asset.jpeg"
          dateText={t('eventsPage.cards.ecoFarm.dateText')}
          timeText={t('eventsPage.cards.ecoFarm.timeText')}
          location={t('eventsPage.cards.ecoFarm.location')}
          mainText={t('eventsPage.cards.ecoFarm.mainText')}
          signUpURL="https://www.eco-farm.org/"
          learnMoreURL="https://www.eco-farm.org/"
        />
      </div>
    </div>
  );
};

export { EventList };
